import React from 'react';
import { Row, Image, Button } from '@thd-olt-component-react/core-ui';
import { generateImageSource } from '../../../utils/generateImageSource';

const ProfileInviteCandidateSection = ({ openModal }) => {

  return (
    <div
      className="p2p-profile-invite-candidate__root"
      data-testid="invite candidate section"
    >
      <div className="p2p-profile-invite-candidate__main">
        <Image
          alt="invite-candidate-mail"
          className="p2p-profile-invite-candidate__icon"
          src={generateImageSource('/images/v1/path-to-pro/invite-candidate-email-icon.svg')}
        />
        <Row className="p2p-profile-invite-candidate__description">
          <span className="p2p-profile-mark-as-hired__orange-text">
            Invite this candidate to apply to one or more active job postings.
          </span>
          <span> Candidates who receive an invitation are more likely to apply.</span>
        </Row>
      </div>
      <div className="p2p-profile-invite-candidate__button-container">
        <Button
          className="p2p-profile-invite-candidate__button"
          data-testid="open-bulk-invite-modal"
          onClick={() => openModal(true)}
        >
          Invite Candidate to Apply
        </Button>
      </div>
    </div>
  );
};

export default ProfileInviteCandidateSection;
